import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowUp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const footerLinks = {
    support: [
      { name: 'Contact Us', href: '#contact' }
    ]
  };

  const socialLinks = []; // Remove social links for MVP

  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <motion.div
            className="footer-brand"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="brand-logo">
              <span className="logo-text">Hemicron</span>
              <span className="logo-dot">.</span>
            </div>
            <p className="brand-description">
              A research team working to improve how we predict migraines, starting
              with getting the measurement right. We welcome migraine sufferers and
              professionals who want to be part of that work.
            </p>
          </motion.div>

          <div className="footer-links">
            <motion.div
              className="link-group"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h4 className="link-group-title">Contact</h4>
              <ul className="link-list">
                <li><a href="mailto:hemicron@gmail.com" className="footer-link">hemicron@gmail.com</a></li>
                <li><a href="tel:+31647495520" className="footer-link">+31 647 495 520</a></li>
              </ul>
            </motion.div>
          </div>
        </div>

        <div className="footer-bottom">
          <motion.div
            className="footer-copyright"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            viewport={{ once: true }}
          >
            <p className="copyright-text">
              © 2026 Hemicron. All rights reserved.
            </p>
            <p className="copyright-subtext">
              This is a research study, not a medical service. Nothing here constitutes
              medical advice. Please consult your healthcare provider for any health concerns.
            </p>
          </motion.div>

          <motion.button
            className="scroll-to-top"
            onClick={scrollToTop}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true }}
          >
            <FaArrowUp />
          </motion.button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
